import React, {useRef, useState} from 'react';
import { setUserGetPricingInfo } from '../store/actions/userAction'
import { useDispatch } from 'react-redux'
import { Grid, Button, TextField } from '@material-ui/core';
import Navigation from '../public/NavbarHomepage'
import ContentBlock from '../public/ContentBlock'
import Product from '../public/Product'
import DetailProduct from '../public/DetailProduct'
import Sdk from '../public/Sdk'
import ContactForm from '../public/ContactForm'
import ScrollToTop from '../commons/ScrollToTop'
import "bootstrap/dist/css/bootstrap.css";
import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const HomepageQuickey = ({ t }) => {
  const dispatch = useDispatch()
  const productSection = useRef(null);
  const contactSection = useRef(null);
  const [lang, setLang] = useState('')

  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleClickOpenPopup = () => {
    setOpen(true);
  };
  const handleClosePopup = () => {
    setOpen(false);
  };

  const [ input, setInput ] = useState({
    email: '',
    phoneNumber: '',
  })

  const handleChangePopupForm = (e) => {
    let { name, value } = e.target
    setInput({ ...input, [name]: value })
  };

  const handleSubmitPopupForm = () => {
    if (!input.email || !input.phoneNumber) {
      console.log('Name and email cannot be empty')
    } else {
      dispatch(setUserGetPricingInfo(input))
      handleClosePopup()
    }
  };


  const gotoSection = (section) => {
    if (section === 'Product' || section === 'Produk') {
      window.scrollTo({
        top: productSection.current.offsetTop,
        behavior: "smooth"
      });   
    } else if (section === 'Contact' || section === 'Kontak') {
      window.scrollTo({
        top: contactSection.current.offsetTop,
        behavior: "smooth"
      });   
    }
  }

  const useStyles = makeStyles((theme) => ({
    root: {
      position: "relative",
    },
    bgHeader: {
      [theme.breakpoints.down("sm")]: {
        width: '100%',
        zIndex: '2',
        position: 'absolute',
        minHeight: '210px',
      },
      [theme.breakpoints.up("sm")]: {
        width: "100%", 
        position: "absolute", 
        zIndex: 2,
        maxHeight: "650px"
      },
    },
    relativeHomepage: {
      position: "relative", zIndex: 3
    },
    backDrop: {
      backdropFilter: "blur(3px)",
      backgroundColor:'rgba(255,255,255,0.8)',
    }
  }));
  
  const classes = useStyles();
  
  const setLocale = (locale) => {
    setLang(locale)
  }
  
  return (
      <>
        <img src="/bg-header.png" alt="Header Background" className={classes.bgHeader}/>
        <Dialog
          fullScreen={fullScreen}
          open={open}
          onClose={handleClosePopup}
          aria-labelledby="responsive-dialog-title"
          BackdropProps={{
            classes: {
              root: classes.backDrop,
            },
          }}
          className='popup-backdrop'
          // onClose={() => {}}
        >
          <DialogContent style={{ backgroundColor: 'black', width:'375px', height: '235px'}}>
            <DialogContentText className='text-white'>
            {t('pricingPopup.title')}
            </DialogContentText>
            <Grid item xs={12} md={12} className='mt-10' style={{width:'100%',backgroundColor:'white'}}>
                <TextField
                  id="email"
                  name='email'
                  color="secondary"
                  required
                  placeholder={t('pricingPopup.email')}
                  style={{height: '30px', width:'100%', backgroundColor:'white', color: 'black'}}
                  value={input.email}
                  onChange={handleChangePopupForm}
                />
            </Grid>
            <Grid item xs={12} md={12} className='mt-15' style={{width:'100%',backgroundColor:'white'}}>
                <TextField
                  id="phoneNumber"
                  name="phoneNumber"
                  color="secondary"
                  required
                  placeholder={t('pricingPopup.phone')}
                  style={{height: '30px', width:'100%', backgroundColor:'white', color: 'black'}}
                  value={input.phoneNumber}
                  onChange={handleChangePopupForm}
                />
            </Grid>
          <DialogActions style={{ backgroundColor: 'black'}}>
            <Button className='mt-10 btn-red' onClick={handleSubmitPopupForm}>
              Submit
            </Button>
          </DialogActions>
          </DialogContent>
        </Dialog>

          <Container fixed className={classes.relativeHomepage}>
            <Navigation section={gotoSection} locale={setLocale} openPricingInfo={handleClickOpenPopup}/>
            <ScrollToTop />
          </Container>
          <Container maxWidth="md" className={classes.relativeHomepage}>
            <ContentBlock locale={lang}/> 
            <div ref={productSection}>
              <h1 className='text-center font-size-28 reguler mb-50'>
                  {t('products.titleProducts')}
              </h1>
              <Product/>
            </div>
            <br/><br/><br/>
            <DetailProduct/>
            <br/><br/><br/><br/>
            <Sdk/>
            <br/><br/><br/><br/>
          </Container>
          <div ref={contactSection}>
            <ContactForm/>
          </div>
      </>
    )
}

export default  withTranslation()(HomepageQuickey);
